import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import {
  Box,
  Button,
  Heading,
  Text,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,Tooltip
} from "@chakra-ui/react";

import Vector from "./Vector";
import { connect } from "react-redux";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  DrawerOverlay,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  useDisclosure,
  Input,
  Center,
  Flex,
  Select,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { HiOutlinePencil } from "react-icons/hi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { addWebhook } from "../../../../redux/actions/integrationActions";
const Webhook = ({ webhookform,configType, dispatchAddWebhook }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const [formValues, setFormValues] = useState([
    { resHeaderKey_0: "", resHeaderValue_0: "" },
  ]);
  const [account, setAccount] = useState([
    {
      webhookname: "",
      requesturl: "",
      requestmethod: "",
      requestformat: "",
    },
  ]);
  const [responseformValues, responsesetFormValues] = useState([
    {
      resBodyKey_0: "",
      resBodyValue_0: "",
    },
  ]);
  const [indexValue, setIndexValue] = useState("");

  let handleChange = (i, e) => {
    let newFormValues = JSON.parse(JSON.stringify(formValues));
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  let inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newAccountValues = JSON.parse(JSON.stringify(account));
    newAccountValues[0][name] = value;
    setAccount(newAccountValues);
  };

  let responsehandleChange = (i, e) => {
    let newResponseFormValues = JSON.parse(JSON.stringify(responseformValues));
    newResponseFormValues[i][e.target.name] = e.target.value;
    responsesetFormValues(newResponseFormValues);
  };

  let addFormFields = () => {
    setFormValues([...formValues, {}]);
  };
  let addResponseFormFields = () => {
    responsesetFormValues([...responseformValues, {}]);
  };
  let removeResponseFormFields = (i) => {
    let newResponseFormValues = [...responseformValues];
    newResponseFormValues.splice(i, 1);
    responsesetFormValues(newResponseFormValues);
  };
  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const onClickHandler = (i, type) => {
    if (type == "edit") {
      onOpen();
      setAccount([
        {
          webhookname: webhookform[i][0],
          requesturl: webhookform[i][1],
          requestmethod: webhookform[i][2],
          requestformat: webhookform[i][3],
        },
      ]);
      setFormValues(webhookform[i][4]);
      responsesetFormValues(webhookform[i][5]);
      setIndexValue(i);
    }
    if (type == "delete") {
      const integrationWebhook = JSON.parse(JSON.stringify(webhookform)).filter(
        (e, index) => {
          if (index != i) {
            return e;
          }
        }
      );
      dispatchAddWebhook(integrationWebhook);
    }
  };

  const addNewWebhook = () => {
    onOpen();
    setAccount([
      {
        webhookname: "",
        requesturl: "",
        requestmethod: "",
        requestformat: "",
      },
    ]);
    setFormValues([{ resHeaderKey_0: "", resHeaderValue_0: "" }]);
    responsesetFormValues([
      {
        resBodyKey_0: "",
        resBodyValue_0: "",
      },
    ]);
    setIndexValue("");
  };

  const renderHeader = () => {
    return webhookform.map((webhook, i) => {
      return (
        <Box key={i}>
          <Tr key={i} height="48px">
            <Th key={i + 1} width="100%">
              <Text fontSize="14px" fontWeight="600" color="#12344D">{webhook[0]}</Text>
            </Th>
            <Th key={i + 2}>
              {" "}
              <Box key={i + 3}>
                <Flex
                  key={i + 4}
                  ml="1"
                  className="form-list-item__actions"
                  alignItems="right"
                >
                  <Center
                    onClick={() => onClickHandler(i, "edit")}
                    cursor="pointer"
                  >
                    <HiOutlinePencil style={{width:"20px"
                    ,height:"20px"}}/>
                  </Center>
                  {"  "}
                  <Center
                    cursor="pointer"
                    onClick={() => onClickHandler(i, "delete")}
                  >
                    <RiDeleteBin6Line style={{width:"20px"
                    ,height:"20px",marginLeft:"18px",marginRight:"14px"}}/>
                  </Center>
                </Flex>
              </Box>
            </Th>
          </Tr>
        </Box>
      );
    });
  };
  const submit = (e) => {
    e.preventDefault();
    let currentWebhook = [
      account[0].webhookname,
      account[0].requesturl,
      account[0].requestmethod,
      account[0].requestformat,
      formValues,
      //responseformValues,
    ];
    onClose();
    const integrationWebhook = JSON.parse(JSON.stringify(webhookform));
    (typeof indexValue =="number")
      ? (integrationWebhook[indexValue] = currentWebhook)
      : integrationWebhook.push(currentWebhook);
    dispatchAddWebhook(integrationWebhook);
  };
  return (
    <Box w="616px" h="288px">
      <Heading
        mb="16px"
        as="h4"
        // w="92px"
        //  h="24px"
        fontSize="18px"
        fontWeight="600"
        color="#12344D"
      >
        Webhooks
      </Heading>
      <Box border="1px" w="616px" h="248px" borderColor="#EBEFF3">
        <Box
          backgroundColor="#F5F7F9"
          h="48px"
          style={{
            position: "relative",
          }}
        >
          <Text
            ml="25px"
            pt="10px"
            h="20px"
            w="184px"
            color="#475867"
            fontSize="14px"
            fontWeight="600"
          >
            {" "}
            Connected Webhooks
          </Text>
          <Button
            className="wehbook-button"
            isDisabled={configType=="NOT_CRM_USER"? false:true} 
            w="124px"
            h="24px"
            ml="475px"
            style={{
              position: "absolute",
              transform: `translateY(${-50}%)`,
              float: "right",
              background: `linear-gradient(${180}deg, #FFFFFF 0%, #F5F7F9 100%)`,
            }}
            fontWeight="600"
            color="#12344D"
            fontSize="12px"
            borderRadius="4px"
            borderColor="1px solid #CFD7DF"
            variant="outline"
            onClick={() => {
              addNewWebhook();
            }}
            ref={btnRef}
          >
            Add new webhook
          </Button>
        </Box>

        <Box className="webhook-box">
          <Drawer
            isOpen={isOpen}
            placement="right"
            onClose={onClose}
            finalFocusRef={btnRef}
            size={"lg"}
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader style={{paddingLeft:"16px"}}>Add new webhook</DrawerHeader>
              <DrawerBody style={{paddingLeft:"16px"}}>
                <FormControl isRequired>
                  {account.map((e, i) => {
                    return (
                      <div key={i}>
                        <FormLabel>Enter webhook name</FormLabel>
                        <Input
                          type="text"
                          placeholder="Enter name"
                          name="webhookname"
                          fontSize="14px"
                          fontWeight="600"
                          color="#12344D"
                          w="566px"
                          h="32px"
                          borderRadius="4px"
                          border="1px"
                          borderStyle="solid"
                          borderColor="#CFD7DF"
                          onChange={inputHandler}
                          value={account[0].webhookname || ""}
                        />
                      </div>
                    );
                  })}
                  <FormControl>
                    {account.map((e, i) => {
                      return (
                        <div key={i}>
                          <FormLabel mt="24px">
                            Request URL  <Tooltip
            label="Enter webhook URL."
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
                          </FormLabel>
                          <Input
                            type="text"
                            fontSize="14px"
                            fontWeight="600"
                            color="#12344D"
                            w="566px"
                            h="32px"
                            borderRadius="4px"
                            border="1px"
                            borderStyle="solid"
                            borderColor="#CFD7DF"
                            placeholder="Enter a request URL"
                            name="requesturl"
                            onChange={inputHandler}
                            value={account[0].requesturl || ""}
                          />
                          <FormLabel mt="16px">
                            Request method  <Tooltip
            label="Select a request method for to make a update"
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
                          </FormLabel>
                          <Select
                            fontSize="14px"
                            fontWeight="600"
                            color="#12344D"
                            // w="566px"
                            h="32px"
                            borderRadius="4px"
                            border="1px"
                            borderStyle="solid"
                            borderColor="#CFD7DF"
                            width="282px"
                            name="requestmethod"
                            onChange={inputHandler}
                            value={account[0].requestmethod || ""}
                          >
                            <option value="" style={{ fontSize:"14px",
                            fontWeight:"600",
                            color:"#12344D"}}>Select Method</option>
                            <option value="post" style={{ fontSize:"14px",
                            fontWeight:"600",
                            color:"#12344D"}}>POST</option>
                            <option value="put" style={{ fontSize:"14px",
                            fontWeight:"600",
                            color:"#12344D"}}>PUT</option>
                          </Select>
                          <FormLabel mt="16px">
                            Request Format  <Tooltip
            label="Select a request format for send the data in the format to the request URL."
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
                          </FormLabel>
                          <Select
                            fontSize="14px"
                            fontWeight="600"
                            color="#12344D"
                            // w="566px"
                            h="32px"
                            borderRadius="4px"
                            border="1px"
                            borderStyle="solid"
                            borderColor="#CFD7DF"
                            width="282px"
                            name="requestformat"
                            onChange={inputHandler}
                            value={account[0].requestformat || ""}
                          >
                            <option value="" style={{ fontSize:"14px",
                            fontWeight:"600",
                            color:"#12344D"}}>Select Format</option>
                            <option value="json" style={{ fontSize:"14px",
                            fontWeight:"600",
                            color:"#12344D"}}>JSON</option>
                          </Select>
                        </div>
                      );
                    })}
                    <FormLabel mt="16px">Request Headers</FormLabel>
                    {formValues.map((element, index) => (
                      <div className="form-inline" key={index} style={{marginTop:"4px",width:"567px"}}>
                        <Icon
                          width="20px"
                          height="20px"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => removeFormFields(index)}
                        >
                          <path
                            d="M10.2637 18.2812C5.84539 18.2812 2.26367 14.6995 2.26367 10.2812C2.26367 5.86297 5.84539 2.28125 10.2637 2.28125C14.6819 2.28125 18.2637 5.86297 18.2637 10.2812C18.2637 12.403 17.4208 14.4378 15.9205 15.9381C14.4202 17.4384 12.3854 18.2812 10.2637 18.2812Z"
                            fill="#92A2B1"
                          />
                          <path
                            d="M14.2637 10.282C14.2637 9.89543 13.9503 9.58203 13.5637 9.58203H6.96367C6.71359 9.58203 6.4825 9.71545 6.35745 9.93203C6.23241 10.1486 6.23241 10.4155 6.35745 10.632C6.4825 10.8486 6.71359 10.982 6.96367 10.982H13.5637C13.9503 10.982 14.2637 10.6686 14.2637 10.282Z"
                            fill="white"
                          />
                        </Icon>{" "}
                        <Input
                        fontSize="14px"
                        fontWeight="600"
                        color="#12344D"
                          type="text"
                          placeholder="Enter a parameter Key"
                          ml="16px"
                          width="255px"
                          name={`resHeaderKey_${index}`}
                          h="32px"
                          value={element[`resHeaderKey_${index}`] || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                        <Input
                                                fontSize="14px"
                                                fontWeight="600"
                                                color="#12344D"
                          type="text"
                          placeholder="Enter a parameter Value"
                          width="255px"
                          h="32px"
                          name={`resHeaderValue_${index}`}
                          float="right"
                          ml="16px"
                          value={element[`resHeaderValue_${index}`] || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </div>
                    ))}
                    <div style={{width:"58px", height:"24px"}}>
                      {/* {Add Requestfield} */}
                      <Icon
                        width="60"
                        height="26"
                        mt="8px"
                        viewBox="87 0 60 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => addFormFields()}
                      >
                        <rect
                          x="1.26367"
                          y="1.28125"
                          width="58"
                          height="24"
                          rx="4"
                          fill="url(#paint0_linear_6333_7251)"
                        />
                        <path
                          d="M16.2641 7.68164C13.1713 7.68164 10.6641 10.1888 10.6641 13.2816C10.6641 16.3744 13.1713 18.8816 16.2641 18.8816C19.3569 18.8816 21.8641 16.3744 21.8641 13.2816C21.8641 11.7964 21.2741 10.372 20.2239 9.32184C19.1737 8.27164 17.7493 7.68164 16.2641 7.68164Z"
                          fill="#2C5CC5"
                        />
                        <path
                          d="M19.0629 13.2805C19.0629 13.5511 18.8435 13.7705 18.5729 13.7705H16.7529V15.5905C16.7529 15.8611 16.5335 16.0805 16.2629 16.0805C15.9923 16.0805 15.7729 15.8611 15.7729 15.5905V13.7705H13.9529C13.6823 13.7705 13.4629 13.5511 13.4629 13.2805C13.4629 13.0098 13.6823 12.7905 13.9529 12.7905H15.7729V10.9705C15.7729 10.6998 15.9923 10.4805 16.2629 10.4805C16.5335 10.4805 16.7529 10.6998 16.7529 10.9705V12.7905H18.5729C18.8435 12.7905 19.0629 13.0098 19.0629 13.2805Z"
                          fill="white"
                        />
                        <path
                          d="M27.6797 17.2812H29.2617L29.9648 15.0957H33.0938L33.8027 17.2812H35.3848L32.3848 8.82617H30.6797L27.6797 17.2812ZM31.4824 10.3965H31.582L32.7188 13.9297H30.3457L31.4824 10.3965ZM38.6426 17.3867C39.5449 17.3867 40.2363 16.9766 40.5879 16.2793H40.6875V17.2812H42.1523V8.39844H40.6875V11.8965H40.5879C40.2539 11.2051 39.5215 10.7715 38.6426 10.7715C37.0195 10.7715 36.0176 12.0371 36.0176 14.0762V14.0879C36.0176 16.1152 37.0371 17.3867 38.6426 17.3867ZM39.0996 16.1562C38.1035 16.1562 37.5 15.377 37.5 14.0879V14.0762C37.5 12.7871 38.1094 12.002 39.0996 12.002C40.0898 12.002 40.7109 12.793 40.7109 14.0762V14.0879C40.7109 15.3711 40.0957 16.1562 39.0996 16.1562ZM46.2949 17.3867C47.1973 17.3867 47.8887 16.9766 48.2402 16.2793H48.3398V17.2812H49.8047V8.39844H48.3398V11.8965H48.2402C47.9062 11.2051 47.1738 10.7715 46.2949 10.7715C44.6719 10.7715 43.6699 12.0371 43.6699 14.0762V14.0879C43.6699 16.1152 44.6895 17.3867 46.2949 17.3867ZM46.752 16.1562C45.7559 16.1562 45.1523 15.377 45.1523 14.0879V14.0762C45.1523 12.7871 45.7617 12.002 46.752 12.002C47.7422 12.002 48.3633 12.793 48.3633 14.0762V14.0879C48.3633 15.3711 47.748 16.1562 46.752 16.1562Z"
                          fill="#12344D"
                        />
                        <rect
                          x="1.26367"
                          y="1.28125"
                          width="58"
                          height="24"
                          rx="4"
                          stroke="#CFD7DF"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_6333_7251"
                            x1="30.2637"
                            y1="1.28125"
                            x2="30.2637"
                            y2="25.2812"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="#F5F7F9" />
                          </linearGradient>
                        </defs>
                      </Icon>
                    </div>

                    {/* <FormLabel mt="16px">Response Body</FormLabel>
                    {responseformValues.map((x, i) => (
                      <div className="form-inline" key={i} style={{marginTop:"4px",width:"567px"}}>
                        <Icon
                          width="20px"
                          height="20px"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => removeResponseFormFields(i)}
                        >
                          <path
                            d="M10.2637 18.2812C5.84539 18.2812 2.26367 14.6995 2.26367 10.2812C2.26367 5.86297 5.84539 2.28125 10.2637 2.28125C14.6819 2.28125 18.2637 5.86297 18.2637 10.2812C18.2637 12.403 17.4208 14.4378 15.9205 15.9381C14.4202 17.4384 12.3854 18.2812 10.2637 18.2812Z"
                            fill="#92A2B1"
                          />
                          <path
                            d="M14.2637 10.282C14.2637 9.89543 13.9503 9.58203 13.5637 9.58203H6.96367C6.71359 9.58203 6.4825 9.71545 6.35745 9.93203C6.23241 10.1486 6.23241 10.4155 6.35745 10.632C6.4825 10.8486 6.71359 10.982 6.96367 10.982H13.5637C13.9503 10.982 14.2637 10.6686 14.2637 10.282Z"
                            fill="white"
                          />
                        </Icon>{" "}
                        <Input
                                                fontSize="14px"
                                                fontWeight="600"
                                                color="#12344D"
                          type="text"
                          ml="16px"
                          placeholder="Enter a parameter Key"
                          width="255px"
                          h="32px"
                          name={`resBodyKey_${i}`}
                          //mt="16px"
                          value={x[`resBodyKey_${i}`] || ""}
                          onChange={(e) => responsehandleChange(i, e)}
                        />
                        <Input
                                                fontSize="14px"
                                                fontWeight="600"
                                                color="#12344D"
                          type="text"
                          placeholder="Enter a parameter Value"
                          name={`resBodyValue_${i}`}
                          float="right"
                          width="255px"
                          h="32px"
                          //mt="16px"
                          ml="16px"
                          value={x[`resBodyValue_${i}`] || ""}
                          onChange={(e) => responsehandleChange(i, e)}
                        />
                      </div>
                    ))} */}
                    {/* <Add Response field> */}
                    {/* <div style={{width:"58px", height:"24px"}}>
                    <Icon
                      width="60"
                      height="26"
                      mt="8px"
                      viewBox="87 0 60 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => addResponseFormFields()}
                    >
                      <rect
                        x="1.26367"
                        y="1.28125"
                        width="58"
                        height="24"
                        rx="4"
                        fill="url(#paint0_linear_6333_7251)"
                      />
                      <path
                        d="M16.2641 7.68164C13.1713 7.68164 10.6641 10.1888 10.6641 13.2816C10.6641 16.3744 13.1713 18.8816 16.2641 18.8816C19.3569 18.8816 21.8641 16.3744 21.8641 13.2816C21.8641 11.7964 21.2741 10.372 20.2239 9.32184C19.1737 8.27164 17.7493 7.68164 16.2641 7.68164Z"
                        fill="#2C5CC5"
                      />
                      <path
                        d="M19.0629 13.2805C19.0629 13.5511 18.8435 13.7705 18.5729 13.7705H16.7529V15.5905C16.7529 15.8611 16.5335 16.0805 16.2629 16.0805C15.9923 16.0805 15.7729 15.8611 15.7729 15.5905V13.7705H13.9529C13.6823 13.7705 13.4629 13.5511 13.4629 13.2805C13.4629 13.0098 13.6823 12.7905 13.9529 12.7905H15.7729V10.9705C15.7729 10.6998 15.9923 10.4805 16.2629 10.4805C16.5335 10.4805 16.7529 10.6998 16.7529 10.9705V12.7905H18.5729C18.8435 12.7905 19.0629 13.0098 19.0629 13.2805Z"
                        fill="white"
                      />
                      <path
                        d="M27.6797 17.2812H29.2617L29.9648 15.0957H33.0938L33.8027 17.2812H35.3848L32.3848 8.82617H30.6797L27.6797 17.2812ZM31.4824 10.3965H31.582L32.7188 13.9297H30.3457L31.4824 10.3965ZM38.6426 17.3867C39.5449 17.3867 40.2363 16.9766 40.5879 16.2793H40.6875V17.2812H42.1523V8.39844H40.6875V11.8965H40.5879C40.2539 11.2051 39.5215 10.7715 38.6426 10.7715C37.0195 10.7715 36.0176 12.0371 36.0176 14.0762V14.0879C36.0176 16.1152 37.0371 17.3867 38.6426 17.3867ZM39.0996 16.1562C38.1035 16.1562 37.5 15.377 37.5 14.0879V14.0762C37.5 12.7871 38.1094 12.002 39.0996 12.002C40.0898 12.002 40.7109 12.793 40.7109 14.0762V14.0879C40.7109 15.3711 40.0957 16.1562 39.0996 16.1562ZM46.2949 17.3867C47.1973 17.3867 47.8887 16.9766 48.2402 16.2793H48.3398V17.2812H49.8047V8.39844H48.3398V11.8965H48.2402C47.9062 11.2051 47.1738 10.7715 46.2949 10.7715C44.6719 10.7715 43.6699 12.0371 43.6699 14.0762V14.0879C43.6699 16.1152 44.6895 17.3867 46.2949 17.3867ZM46.752 16.1562C45.7559 16.1562 45.1523 15.377 45.1523 14.0879V14.0762C45.1523 12.7871 45.7617 12.002 46.752 12.002C47.7422 12.002 48.3633 12.793 48.3633 14.0762V14.0879C48.3633 15.3711 47.748 16.1562 46.752 16.1562Z"
                        fill="#12344D"
                      />
                      <rect
                        x="1.26367"
                        y="1.28125"
                        width="58"
                        height="24"
                        rx="4"
                        stroke="#CFD7DF"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_6333_7251"
                          x1="30.2637"
                          y1="1.28125"
                          x2="30.2637"
                          y2="25.2812"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="white" />
                          <stop offset="1" stopColor="#F5F7F9" />
                        </linearGradient>
                      </defs>
                    </Icon></div> */}
                  </FormControl>
                </FormControl>
              </DrawerBody>
              <DrawerFooter style={{paddingLeft:"0px"}}>
<Box h="56px" bg="#F5F7F9" width="100%" ><Box style={{    float: "right",    transform: `translateY(50%)`}}>                <Button borderRadius="4px" border="1px" borderStyle="soild" borderColor="#CFD7DF" style={{background: `linear-gradient(${180}deg,  #FFFFFF 0%, #F5F7F9 100%)`,padding: "6px 12px"}} fontSize="14px" fontWeight="600" color="#12344D"   w="72px" h="32px" mr="12px"  onClick={onClose}>
                  Cancel
                </Button>
                <Button borderRadius="4px" border="1px" borderStyle="soild" borderColor="#12344D" style={{background: `linear-gradient(${180}deg, #264966 0%, #12344D 100%)`,padding: "6px 12px"}} fontSize="14px" fontWeight="600" color="#FFFFFF" w="57px" h="32px" mr="16px" onClick={submit}>
                  Save
                </Button></Box>
</Box>              </DrawerFooter>
            </DrawerContent>
          </Drawer>
        </Box>
        {webhookform && webhookform.length ? (
          <Box>
            <Table key="1">
              <Thead>{renderHeader()}</Thead>
            </Table>
          </Box>
        ) : (
          <>
            <Flex align="center" direction="column" justify="center">
              <Box
                w="123px"
                h="120px"
                mt="22.5px"
                mb="9.5px"
                ml="247.02px"
                mr="245.99px"
              >
                <Vector />
              </Box>
            </Flex>
            <Text
              align="center"
              fontSize="14px"
              fontWeight="400"
              color="#475867"
            >
              No webhooks connected
            </Text>
          </>
        )}
      </Box>
    </Box>
  );
};
const mapStateToProps = (state) => {
  return {
    webhookform: state.integration.webhooks,
    configType:state.integration.configType
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchAddWebhook: bindActionCreators(addWebhook, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Webhook);
